import { createAction, props } from '@ngrx/store';
import { asyncProps, FromApiActionPayload, WithRequestId, AsyncRequest } from '@lib';
import { GetFlightsResultModel } from './get-flights-result.state';
import { PostFlightsSearchFlightsResponse } from 'src/sdk_checkin';

/** StateDetailsActions */
const ACTION_SET = '[GetFlightsResult] set';
const ACTION_UPDATE = '[GetFlightsResult] update';
const ACTION_RESET = '[GetFlightsResult] reset';
const ACTION_FAIL = '[GetFlightsResult] fail';
const ACTION_CANCEL_REQUEST = '[GetFlightsResult] cancel request';

/** Async Actions */
const ACTION_SET_FROM_API = '[GetFlightsResult] set from api';
const ACTION_UPDATE_FROM_API = '[GetFlightsResult] update from api';

/**
 * Clear the current store object and replace it with the new one,
 * update isFailure to false, and update isPending with the boolean given as parameter if defined
 */
export const setGetFlightsResult = createAction(ACTION_SET, props<WithRequestId<GetFlightsResultModel>>());

/**
 * Change a part or the whole object in the store and update isFailure to false. The pendingUpdate boolean,
 * if set to true or false, will update the isPending property from the StateDetails
 */
export const updateGetFlightsResult = createAction(
  ACTION_UPDATE,
  props<WithRequestId<Partial<GetFlightsResultModel>>>()
);

/**
 * Clear the whole state, return to the initial one
 */
export const resetGetFlightsResult = createAction(ACTION_RESET);

/** Action to cancel a Request ID registered in the store. Can happen from effect based on a switchMap for instance */
export const cancelGetFlightsResultRequest = createAction(ACTION_CANCEL_REQUEST, props<AsyncRequest>());

/**
 * Update isPending from the StateDetails to false, and isFailure to true
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const failGetFlightsResult = createAction(ACTION_FAIL, props<WithRequestId<{ error: any }>>());

/**
 * Update isPending to true, triggers setFromApi Effect
 */
export const setGetFlightsResultFromApi = createAction(
  ACTION_SET_FROM_API,
  asyncProps<FromApiActionPayload<PostFlightsSearchFlightsResponse>>()
);

/**
 * Update isPending to true, triggers updateFromApi Effect
 */
export const updateGetFlightsResultFromApi = createAction(
  ACTION_UPDATE_FROM_API,
  asyncProps<FromApiActionPayload<PostFlightsSearchFlightsResponse>>()
);
